<template>
    <main>
        
        <component-home v-if="!session"/>
        <dashboard v-if="session"/>
        <Footer v-if="session"/>
    </main>
</template>
<script>
//import renderauthsocialnetwork from '../../../../helpers/renderauthsocialnetwork'
// var popupcontent = '<br><button class="btn btn-warning btn-sm" style="color: white;margin:5% 0% 0% 35%;" @click="addStops(' + loc + ')">Add</button>'
import { LMap, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker } from 'vue2-leaflet'
// Import the EventBus we just created.
import { EventBus } from '../../../../helpers/eventbus/event-bus.js'
import config from './../../../../config/env.example'

//Componentes
import Navbar from '../../Views/Navbar'
import Footer from '../../Views/footer'
import userprofile from '../../Views/userprofile'
import dashboard from '../../Views/dashboard'
import companyregister from '../../Views/companyregister'
import modalquestions from '../../Views/modalquestions'
import home from './home'

import initVue from '../../../../helpers/initVue'

import Maps from '../../Views/Maps'

import editnewusers from '../../../../models/editnewuser'


import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    data () { 
      return { 
        n: 20,
        valid:true, 
        dialog3:false,
        dialog4: false,
        identity: null,
        session: false,
        token: null,
        userstorage: {},
        users: new editnewusers(),
        imageName: '',
        imageUrl: '',
        imageFile: '',
        addressempty: false,
        rules: {
                required: value => !!value || 'requerido.'
            }
      }
    },

    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),

    mounted(){
        this.getidentity()
        this.getuser()
    },

    components:{
        Navbar, dashboard, userprofile, Footer, companyregister,
        'component-maps':Maps, 'component-questions':modalquestions, 'component-home':home
        
    },
    methods: {
        menushow(){
                document.getElementById("sidebar").style = `
                    transform: translateX(0);
                `
        },
        menuhide(){
                    document.getElementById("sidebar").style = `
                        translateX(-100%);
                    `
        },

 /* * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.session)
        },

        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        opendialog3(){
          this.dialog3=true
        },

        opendialog4(){
          this.dialog4 = true
          this.dialog3 = false
        },

        closedialog4(){
            this.dialog4 = false
        },


        getuser(){
            if(this.session){
                this.axios.get(`users/getuser`)
                /******************* * Login Exitoso!!!!******************************* */
                .then((res) => {
                    this.userstorage = res.data.user
                    this.imageUrl = this.userstorage.photo
                    let newuser = this.identity.statususer === 'newuser' && this.userstorage.address === ''
                    if(newuser){
                        this.opendialog3()
                    }

                })
                /******************* * Login Errado!!!!********************************/
                .catch((err) => {
                    console.log(err)
                })
            }
        },

        pickFile () {
            this.$refs.image.click()
        },
        onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
                }
                
                if (!(/\.(jpg|png|gif|jpeg)$/i).test(this.imageName))
                {
                    alert('Comprueba la extensión de tus imagenes, recuerda que los formatos aceptados son .gif, .jpeg, .jpg y .png');
                    this.imageName = ''
                    this.imageUrl = this.userstorage.photo
                }else{
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                        this.imageName = files[0].name
                        //console.log(this.imageUrl)


                    })
                }
			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = this.userstorage.photo
			}
        },

        editdatanewuser(){
            if (this.$refs.form.validate()) {
                this.snackbar = true
                this.users.imageFile = this.imageUrl
                this.axios.put(`users/editnewuser/${this.identity._id}/${this.token}`, this.users)
                .then((res) =>{
                    this.getuser()
                    EventBus.$emit('getuser')
                    this.closedialog4()
                })

                .catch((err) =>{
                    this.getuser()
                    EventBus.$emit('getuser')
                    console.log(err)

                })
            }

        }, 



    }

}

</script>